import client from '@/api/client.js';
import jobmixin from '@/helpers/Mixins/JobMixin.js';
import store from "@/store";
export default {
    methods: {
        async getJobListFromFilter(filter, cancelationToken) {
            //manual convertion from substatus 0 to null for backend. 
            //done this way for dropdowns to work properly as they dont diff value null and no value
            var index = filter?.JobSubStatusIdList?.indexOf(0);
            //console.log('index', index);
            if (index > -1) {
                filter.JobSubStatusIdList[index] = null;
            }
            //console.log('filter', filter);
            
            var meta = { clientApiMethod: 'getJobListFromFilter', input: { filter: filter } }
            var response = await client().post(store.state.apiRouteRoot + "JobList/Filtered", filter, { signal: cancelationToken, meta: meta })
            if (response && response.data && response.data.LimitedList && response?.data.LimitedList.length) {
                response.data.LimitedList = response?.data.LimitedList.map((e) => { return jobmixin.methods.setAgos(e); });
            }
            return response?.data;
        },
    }
}